import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../redux/store';
import {hideConfirm} from '../redux/reducers/confirmReducer';

const ConfirmDialog = () => {
    const dispatch = useDispatch();
    const {open, title, message, onConfirm} = useSelector((state: RootState) => state.confirm);

    const handleClose = () => {
        dispatch(hideConfirm());
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        dispatch(hideConfirm());
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
        >
            <DialogTitle id="confirm-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirm-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    İptal
                </Button>
                <Button onClick={handleConfirm} color="primary" variant="contained" autoFocus>
                    Onayla
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
